import { useCallback, useRef, useState } from 'react';
import ButtonIcon from 'components/ButtonIcon';
import Download from 'components/icons/download';
import HiddenAnchor from 'components/HiddenAnchor';
import { ActionsCellWrapper } from './styled';

interface Props {
    row?: any;
}

const Actions = ({ row }: Props) => {
    const { url, name, customMetadata } = row || {};
    const hiddenLinkRef = useRef<HTMLAnchorElement>(null);
    const [isDownloading, setIsDownloading] = useState(false);

    const originalName = customMetadata?.originalName || row.name;

    const download = useCallback(async () => {
        if (!hiddenLinkRef.current) return;

        setIsDownloading(true);
        const originalExt = originalName.split('.').pop();
        try {
            const res = await fetch(url);
            const blob = await res.blob();
            const downloadUrl = URL.createObjectURL(blob);
            hiddenLinkRef.current.href = downloadUrl;
            hiddenLinkRef.current.download = `${name}.${originalExt}`;
            hiddenLinkRef.current.click();
        } catch (error) {
            console.error('Error downloading file', error);
        }
    }, [name, originalName, url]);

    return (
        <ActionsCellWrapper>
            <HiddenAnchor ref={hiddenLinkRef} />
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Download />}
                tooltip="Download File"
                size="small"
                onClick={download}
                disabled={isDownloading}
            />
        </ActionsCellWrapper>
    );
};

export default Actions;
